module.exports = __webpack_public_path__ + "static/media/281007.626e0e82.png";